// Information drawers on the product page (financing, store pickup, battery eco-fee).
// They reuse the cart drawer markup and styles, so they slide in from the right the
// same way. Any element with data-info-drawer-open="<drawer id>" opens the drawer.
if (!customElements.get('product-info-drawer')) {
  class ProductInfoDrawer extends HTMLElement {
    connectedCallback() {
      // Live under <body> so no transformed or sticky ancestor can trap the fixed overlay.
      // Moving the node fires connectedCallback again, hence the early return.
      if (this.parentElement !== document.body) {
        document.querySelectorAll(`body > product-info-drawer[id="${this.id}"]`).forEach((stale) => stale.remove());
        document.body.appendChild(this);
        return;
      }
      if (this.initialized) return;
      this.initialized = true;

      this.header = document.querySelector('.header-wrapper');
      this.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
      this.querySelectorAll('[data-info-drawer-close]').forEach((element) =>
        element.addEventListener('click', this.close.bind(this))
      );
    }

    open(opener) {
      this.opener = opener;
      if (this.header) this.header.preventHide = true;
      // Same timeout as the cart drawer: the transition doesn't always trigger without it
      setTimeout(() => this.classList.add('animate', 'active'));

      this.addEventListener(
        'transitionend',
        () => {
          const inner = this.querySelector('.drawer__inner');
          trapFocus(inner, inner);
        },
        { once: true }
      );

      document.body.classList.add('overflow-hidden-drawer');
    }

    close() {
      if (!this.classList.contains('active')) return;
      this.classList.remove('active');
      removeTrapFocus(this.opener);
      document.body.classList.remove('overflow-hidden-drawer');
      if (this.header) this.header.preventHide = false;
    }
  }

  customElements.define('product-info-drawer', ProductInfoDrawer);

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-info-drawer-open]');
    if (!opener) return;
    const drawer = document.getElementById(opener.dataset.infoDrawerOpen);
    if (!drawer) return;
    event.preventDefault();
    drawer.open(opener);
  });
}
